import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.ListDealerDocuments.IRequest;
type Response = Api.Core.ProductDocument.ListDealerDocuments.IResponse;
type Headers = Api.Core.ProductDocument.ListDealerDocuments.IHeaders;
const url = '/api/ProductManagement/ProductDealerDocument/DealerDocuments';
export default async function productDocumentListDealerDocumentsApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
